import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 税率
 */
class TaxRate extends UltMeta {
    THREE = new Meta(1, "3%", 0.03);
    SIX = new Meta(2, "6%", 0.06);
    NINE = new Meta(3, "9%", 0.09);
    THIRTEEN = new Meta(4, "13%", 0.13);
}

export const TAX_RATE = new TaxRate();

/**
 * 广告观看时间
 */
class AdvertisingWatchTime extends UltMeta {
    TEN_SECOND = new Meta(1, "10秒");
    FIFTEEN_SECOND = new Meta(2, "15秒");
    THIRTY_SECOND = new Meta(3, "30秒");
    SIXTY_SECOND = new Meta(4, "60秒");
}

export const ADVERTISING_WATCH_TIME = new AdvertisingWatchTime();

/**
 * 等待付款时间
 */
class WaitingPayTime extends UltMeta {
    THIRTY_MINUTE = new Meta(1, "30分钟");
    SIXTY_MINUTE = new Meta(2, "60分钟");
    TWELVE_HOUR = new Meta(3, "12小时");
    TWENTY_FOUR_HOUR = new Meta(4, "24小时");
    FORTY_EIGHT_HOUR = new Meta(5, "48小时");
    SEVENTY_TWO_HOUR = new Meta(6, "72小时");
}

export const WAITING_PAY_TIME = new WaitingPayTime();

/**
 * 商品状态
 */
class State extends UltMeta {
    UP_SHELF = new Meta(1, "上架");
    DOWN_SHELF = new Meta(2, "下架");
}

export const STATE = new State();

/**
 * 发布状态
 */
class PublishState extends UltMeta {
    PENDING = new Meta(6, "待提交");
    NOT_AUDIT = new Meta(1, "待审核");
    FAIL = new Meta(2, "未通过");
    PASS = new Meta(3, "已发布");
    DOWN_SHELF = new Meta(4, "已下架");
    CLOSE = new Meta(5, "已关闭");
}

export const PUBLISH_STATE = new PublishState();

/**
 * 捡漏状态
 */
class BargainState extends UltMeta {
    WAITING_START = new Meta(1, "待开始");
    BARGAINING = new Meta(2, "捡漏中");
    COMPLETED = new Meta(3, "已完成");
}

export const BARGAIN_STATE = new BargainState();

/**
 * 用户滚动信息状态
 */
class UserScrollInfoState extends UltMeta {
    WAITING_START = new Meta(1, "待开始");
    IN_PROGRESS = new Meta(2, "进行中");
}
export const USER_SCROLL_INFO_STATE = new UserScrollInfoState();
